import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthState, User, MOCK_CREDENTIALS } from '../types/auth';

const useAuthStore = create<AuthState>()(
	persist(
		set => ({
			user: null,
			isAuthenticated: false,

			login: async (email: string, password: string): Promise<boolean> => {
				// Simulate API call delay
				await new Promise(resolve => setTimeout(resolve, 1000));

				// Check credentials against mock data
				const matchedRole = Object.values(MOCK_CREDENTIALS).find(
					cred => cred.email === email && cred.password === password,
				);

				if (matchedRole) {
					set({
						user: matchedRole.user,
						isAuthenticated: true,
					});
					return true;
				}

				return false;
			},

			logout: () => {
				set({
					user: null,
					isAuthenticated: false,
				});
			},

			updateUser: (user: User) => {
				set({ user });
			},
		}),
		{
			name: 'auth-storage',
			partialize: state => ({
				user: state.user,
				isAuthenticated: state.isAuthenticated,
			}),
		},
	),
);

export default useAuthStore;
